<template>
  <div class="relative inline-block text-left z-10">
    <div>
      <span class="rounded-md shadow-sm">
        <Button
          v-on:click-handler="toggle"
          class="btn btn-primary relative z-10"
          :class="{ 'btn-small': ! large }"
          :disabled="disabled"
        >
          Actions
          <LoadingSpinner v-if="loading" class="-mr-1 ml-2 w-5 h-5" />
          <icon
            v-else
            set="solid"
            name="chevron-down"
            class="-mr-1 ml-2 h-5 w-5"
          />
        </Button>
        <button
          v-if="expanded"
          @click="close"
          tabindex="-1"
          class="fixed inset-0 w-full h-full bg-black opacity-50 cursor-default"
        ></button>
      </span>
    </div>

    <transition
      enter-active-class="ease-out duration-100"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="ease-in duration-75"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="expanded"
        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg"
      >
        <div class="rounded-md bg-white shadow-xs">
          <div
            class="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from "@/components/elements/Button.vue";

export default {
  name: "ActionsMenu",
  inheritAttrs: false,
  components: {
    Button
  },
  props: {
    large: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  created() {
    this.$on('actions-menu:close', this.close);
  },
  methods: {
    close() {
      this.expanded = false;
    },
    toggle() {
      this.expanded = ! this.expanded;
    }
  }
};
</script>
